import BaseGenericEvent from '../../BaseGenericEvent';
import {getSearchEventData} from '../../PdtHelper/RailsPdtUtils';
import {RailsPdtConstants} from '../../PdtHelper/RailsPdtConstants';

export default class RailsPdtTravellersEvent extends BaseGenericEvent {
  constructor(pdtData) {
    const data = pdtData;
    data.pageName = RailsPdtConstants.FunnelStep.TRAVELLERS;
    data.funnelStep = RailsPdtConstants.FunnelStep.TRAVELLERS;
    super(data);
    this.searchData = pdtData.searchData;
  }

  trackTravellersEvent = () => {
    const basePdtObject = this.basePdtData();
    basePdtObject.rail_search_context = getSearchEventData(this.searchData);
    return basePdtObject;
  }
}
